module.exports = __webpack_public_path__ + "static/media/Raggiungimi 2.82ca20b4.png";